import React, { useState } from 'react';
import { defaultTranslateFn } from '../../../utilities';
import {
  StyledNotificationRule,
  StyledToggle,
  Name,
  SwitchGroup,
  Label,
} from './styles';

export const NotificationRule: React.FC<NotificationRuleProps> = ({
  className,
  name,
  email,
  inApplication,
  onEmail,
  onInApplication,
  t = defaultTranslateFn,
}) => {
  const [emailState, setEmailState] = useState(email);
  const [inApplicationState, setInApplicationState] = useState(inApplication);

  return (
    <StyledNotificationRule className={className}>
      <Name>{name}</Name>
      <SwitchGroup>
        <Label>{t('In-Application')}</Label>
        <StyledToggle
          label={inApplicationState ? t('ON') : t('OFF')}
          isChecked={inApplicationState}
          onToggle={() => {
            setInApplicationState(!inApplicationState);
            if (onInApplication) {
              onInApplication();
            }
          }}
        />
      </SwitchGroup>
      <SwitchGroup>
        <Label>Email</Label>
        <StyledToggle
          label={emailState ? t('ON') : t('OFF')}
          isChecked={emailState}
          onToggle={() => {
            setEmailState(!emailState);
            if (onEmail) {
              onEmail();
            }
          }}
        />
      </SwitchGroup>
    </StyledNotificationRule>
  );
};

export interface NotificationRuleProps {
  className?: string;
  name: string;
  email: boolean;
  inApplication: boolean;
  onEmail?: () => void;
  onInApplication?: () => void;
  t?: (key: string) => string;
}
